import { executeRequest, Request, Response } from '@jfs/network'
import { Platform } from 'react-native'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: Response) => {
  return response?.status
    ? response?.data
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
        response?.data?.errors?.[0]?.exception?.message ??
        response?.data?.errors?.[0]?.message
}

const returnBody = (merchantId: any) => {
  const filterKeys =
    Platform.OS === 'web'
      ? [
          'contactDetails',
          'addressDetails',
          'settlementDetails',
          'businessProfile',
          'authorisedSignatoryDetails',
          'terminalDetails',
          'entityConfigs',
        ]
      : ['contactDetails', 'settlementDetails']
  const payload: any = {
    identificationNumber: `${merchantId}`,
    filter: {
      keys: filterKeys,
      entityConfigKeys: ['PAYMENT_ACCEPTANCE'],
    },
  }
  return payload
}

export const searchEntity = async (tokens: any, userAccessToken: any, merchantId: any) => {
  const postBody = returnBody(merchantId)
  const config: any = sitConfig(tokens)
  config.retryCount = 0
  config.timeOut = 60000

  const request: Request<{}> = {
    apiPath: APIEndPoints.searchEntity,
    method: 'POST',
    cache: false,
    body: postBody,
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userAccessToken}`,
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error: any) => {
      throw error
    })
}
